import { createAction, props } from '@ngrx/store';

export const loadDownloadPaymentStatements = createAction(
  '[DownloadPaymentStatement] Load DownloadPaymentStatements',
  props<{ downloadLink: string; fileType: string }>()
);

export const loadDownloadPaymentStatementsSuccess = createAction(
  '[DownloadPaymentStatement] Load DownloadPaymentStatements Success',
  props<{ response: any }>()
);

export const loadDownloadPaymentStatementsFailure = createAction(
  '[DownloadPaymentStatement] Load DownloadPaymentStatements Failure',
  props<{ error: Error | any }>()
);
